import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {RemoteMedicalReport} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {GetMedicalReport} from 'domain/usecases';

import {BookedFlowEndPoints} from 'main/factories/usecases/endpoints';
import {HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors';

export const makeGetMedicalReport = (): GetMedicalReport =>
	new RemoteMedicalReport(
		makeBFFApiUrl(BookedFlowEndPoints.medicalReport),
		makeAuthorizeHttpClientDecorator(),
	);

export const makeMockedNotFoundGetMedicalReport = (): GetMedicalReport => ({
	get: async () => {
		throw new APIError(HttpStatusCode.notFound, 'Not Found');
	},
});

export const makeMockedNoContentGetMedicalReport = (): GetMedicalReport => ({
	get: async () => {
		throw new APIError(HttpStatusCode.noContent, 'No Content');
	},
});

export const makeMockedUnexpectedErrorGetMedicalReport = (): GetMedicalReport => ({
	get: async () => {
		throw new APIError(HttpStatusCode.serverError, 'Unexpected Error');
	},
});

export const makeMockedSuccessGetMedicalReport = (): GetMedicalReport => ({
	get: async () => ({
		url: '/mocks/dummy.pdf',
	}),
});
